export { default } from './Linepay'



// WEBPACK FOOTER //
// ./src/App/components/PaymentBlocks/Linepay/index.js